"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: h, size: e = 24 } = _param, a = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = s(), o = h !== null && h !== void 0 ? h : c ? l.colors.inverse : l.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M12.654 11.321h5.254a.679.679 0 0 1 0 1.357h-5.254v5.254a.679.679 0 1 1-1.357 0v-5.254H6.044a.678.678 0 1 1 0-1.357h5.253V6.068a.679.679 0 0 1 1.357 0z"
            }),
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M1.976 12c0 5.327 4.673 10 10 10s10-4.673 10-10-4.673-10-10-10-10 4.673-10 10m1.358 0c0-4.604 4.038-8.643 8.642-8.643S20.618 7.396 20.618 12s-4.038 8.642-8.642 8.642S3.334 16.604 3.334 12"
            })
        ]
    })) : t.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M11.283 5.94a.72.72 0 0 1 .715-.716.72.72 0 0 1 .716.715v5.346l5.34.006a.72.72 0 0 1 .716.715c0 .198-.08.38-.207.507a.73.73 0 0 1-.506.206H12.71v5.346a.7.7 0 0 1-.713.713.72.72 0 0 1-.715-.716v-5.346H5.937a.72.72 0 0 1-.716-.715.72.72 0 0 1 .716-.716h5.346z"
            }),
            /* @__PURE__ */ r("path", {
                fill: o,
                d: "M12 2C6.484 2 2 6.484 2 12s4.484 10 10 10 10-4.484 10-10S17.516 2 12 2m0 18.576c-4.728 0-8.576-3.848-8.576-8.576S7.272 3.424 12 3.424 20.576 7.272 20.576 12 16.728 20.576 12 20.576"
            })
        ]
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ r("path", {
            fill: o,
            d: "M23 12.028C23 1.914 14.617 1.063 12.457 1.01c-.247-.006-.538-.009-.82-.009h-.22C9.208 1.019 1 1.776 1 11.966c0 10.201 8.286 11 10.496 11.03q.178.005.357.004c.228 0 .454-.003.651-.006C14.601 22.953 23 22.167 23 12.028M12.476 21.62q-.48.01-.958.004c-2.749-.038-9.14-1.058-9.14-9.657 0-8.587 6.329-9.567 9.052-9.592h.207q.394 0 .789.01c2.764.065 9.196 1.14 9.196 9.644 0 8.505-6.395 9.541-9.146 9.591M17.48 11.28a.689.689 0 0 1 0 1.377h-4.799v4.808a.689.689 0 0 1-1.377 0v-4.81h-4.79a.689.689 0 0 1 0-1.378h4.79V6.534a.689.689 0 0 1 1.377 0v4.746z"
        })
    }));
}, u = v;
export { u as default };
